import React from 'react';

import Smartbanner from 'spa/Components/Smartbanner/Smartbanner';

const SmartbannerWrapper = () => <Smartbanner />;

export default SmartbannerWrapper;



// WEBPACK FOOTER //
// ./spa/Components/Smartbanner/SmartbannerWrapper.jsx